import React, { useState, useEffect, useRef } from "react";
// import Breadcrumbs from "../../core/breadcrumbs";
import { Filter } from "react-feather";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Select from "react-select";
import { Link, useNavigate } from "react-router-dom";
import { Archive, Calendar, User } from "react-feather";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import StockTransferModal from "../../core/modals/stocks/stocktransferModal";
import Table from "../../core/pagination/datatable";
import { useDispatch, useSelector } from "react-redux";
import {
  API_BASE_URL,
  GET_TRANSFER_STOCK,
  GET_TRANSFER_STOCK_PDF,
} from "../../Config";
import Axios from "axios";
import { settransferstock_data } from "../../core/redux/action";
import {
  ChevronUp,
  PlusCircle,
  RotateCcw,
} from "feather-icons-react/build/IconComponents";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import IndentStockTransferModal from "../../core/modals/stocks/indentstocktransfer";
import UploadFiles from "../UploadFiles";
import { getUserPermissions } from "../../UserPermissions";
import html2pdf from "html2pdf.js";
// import ReactToPrint from "react-to-print";
import PrintLogoImg from './41115.png';
import SpinLoader from "../loader/SpinLoader";

const StockTransfer = () => {
  const [userDataSession, setUserDataSession] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, []);

  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [editTransferObj, setEditTransferObj] = useState([]);
  const [stockTRPdf, setStockTRPdf] = useState([]);
  const [uploadTransferObj, setUploadTransferObj] = useState("");
  const [uploadType, setUploadType] = useState("");
  const [loading, setLoading] = useState(false);
  const [totalReqQty, setTotalReqQty] = useState(0);
  const [totalTransferQty, setTotalTransferQty] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isVisible1, setIsVisible1] = useState(true);

  const dispatch = useDispatch();
  // const data = useSelector((state) => state.stocktransferdata);
  const dataSource = useSelector((state) => state.transferstock_data) || [];

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      setLoading(true);
      Axios.get(
        `${API_BASE_URL}${GET_TRANSFER_STOCK}?OrgId=${userDataSession.OrgId}&UserId=${userDataSession.UserId}&StoreId=0`
      )
        .then((response) => {
          if (response.data.Status) {
            dispatch(settransferstock_data(response.data.ResultData));
            setLoading(false);
          } else {
            console.error("Error fetching data:", response.data.Message);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  }, [dispatch, userDataSession]);

  const [permissions, setPermissions] = useState({
    isRead: "d-none",
    isWrite: "d-none",
    isDelete: "d-none",
    isExport: "d-none",
  });

  useEffect(() => {
    const perms = getUserPermissions("Transfer");
    setPermissions(perms);
  }, []);

  const filteredData = dataSource.filter(
    (item) =>
      (item && // Check if item is defined
        item.ToStore &&
        item.ToStore.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (item.FromStore &&
        item.FromStore.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (item.IndentNo &&
        item.IndentNo.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (item.TransferOrder &&
        item.TransferOrder.toString().includes(searchQuery.toLowerCase()))
  );

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const warehouseOptions = [
    { value: "Lobar Handy", label: "Lobar Handy" },
    { value: "Quaint Warehouse", label: "Quaint Warehouse" },
    { value: "Traditional Warehouse", label: "Traditional Warehouse" },
    { value: "Cool Warehouse", label: "Cool Warehouse" },
  ];

  const destinationOptions = [
    { value: "Selosy", label: "Selosy" },
    { value: "Logerro", label: "Logerro" },
    { value: "Vesloo", label: "Vesloo" },
    { value: "Crompy", label: "Crompy" },
  ];

  const columns = [
    {
      title: "Order No",
      dataIndex: "AutoGenTransactionNo",
      sorter: (a, b) =>
        a.AutoGenTransactionNo.length - b.AutoGenTransactionNo.length,
      render: (text, record) => `ST-${record.AutoGenTransactionNo}`,
    },

    {
      title: "Date",
      dataIndex: "TransferDate",
      sorter: (a, b) => new Date(a.TransferDate) - new Date(b.TransferDate),
      render: (TransferDate) => {
        const date = new Date(TransferDate);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },
    },

    {
      title: "Indent No",
      dataIndex: "IndentNo",
      sorter: (a, b) => a.IndentNo.length - b.IndentNo.length,
      render: (text) => (text ? text : "N/A"),
    },

    {
      title: "From Store",
      dataIndex: "FromStore",
      sorter: (a, b) => a.FromStore.length - b.FromStore.length,
      render: (text) => (
        <span
          title={text}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "120px",
          }}
        >
          {text.length > 10 ? `${text.substring(0, 10)}...` : text}
        </span>
      ),
    },

    {
      title: "To Store",
      dataIndex: "ToStore",
      sorter: (a, b) => a.ToStore.length - b.ToStore.length,
      render: (text) => (
        <span
          title={text}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "120px",
          }}
        >
          {text.length > 10 ? `${text.substring(0, 10)}...` : text}
        </span>
      ),
    },

    {
      title: "Status",
      dataIndex: "Status",
      sorter: (a, b) => a.Status - b.Status,
      render: (status) => {
        let statusText;
        let className = "badge ";

        switch (status) {
          case "Pending":
            statusText = "Pending";
            className += "bg-outline-warning";
            break;
          case "RECEIVED":
            statusText = "Received";
            className += "bg-outline-success";
            break;
          case "DRAFT":
            statusText = "Draft";
            className += "bg-outline-warning";
            break;
          case "TRANSFERED":
            statusText = "Transfered";
            className += "bg-outline-info";
            break;
          default:
            statusText = status;
            className += "badge-default";
            break;
        }

        return <span className={className}>{statusText}</span>;
      },
    },

    {
      title: "Req Qty",
      dataIndex: "TotalReqQuantity",
      sorter: (a, b) => a.TotalReqQuantity.length - b.TotalReqQuantity.length,
    },

    {
      title: "Trf Qty",
      dataIndex: "TotalTransferQty",
      sorter: (a, b) => a.TotalTransferQty.length - b.TotalTransferQty.length,
    },

    {
      title: "Action",
      key: "action",
      render: (text, record) => {
        const uploadType =
          record.Status === "TRANSFERED"
            ? "StockTransfered"
            : record.Status === "RECEIVED"
            ? "StockReceived"
            : null;

        return (
          <td>
            <div className="edit-delete-action">
              <Link to="#" className="dropdown-toggl" data-bs-toggle="dropdown">
                <i className="fa-solid fa-ellipsis-vertical btn border"></i>
              </Link>
              <div className="dropdown-menu dropdown-menu-right">
                <Link
                  to="#"
                  className="dropdown-item my-3 ms-3"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRightViewStockTrnsf"
                  aria-controls="offcanvasRightViewStockTrnsf"
                  onClick={() => showEditModal(record)}
                >
                  <i className="fa-regular fa-eye me-2"></i>
                  View
                </Link>

                <Link
                  to="#"
                  className={`dropdown-item ms-3 my-3 ${
                    record.Status === "TRANSFERED" ? "" : "disabled"
                  }`}
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRightEditStockTrnsf"
                  aria-controls="offcanvasRightEditStockTrnsf"
                  onClick={() => showEditModal(record)}
                >
                  <i className="fa-regular fa-pen-to-square me-2"></i>
                  Edit
                </Link>

                <Link
                  to="#"
                  className={`dropdown-item ms-3 my-3`}
                  onClick={() => downloadPDF(record.TransferId)}
                >
                  <i className="fa-regular fa-file-pdf me-2"></i>
                  Download Pdf
                </Link>

                <Link
                  to="#"
                  className={`dropdown-item ms-3 my-3`}
                  onClick={() => printRecord(record.TransferId)}
                >
                  <i className="fa-solid fa-print me-2"></i>
                  Print
                </Link>

                <Link
                  to="#"
                  className={`dropdown-item ms-3 my-3 ${
                    record.Status === "TRANSFERED" ? "" : "disabled"
                  }`}
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRightRecStockTrnsf"
                  aria-controls="offcanvasRightRecStockTrnsf"
                  onClick={() => showEditModal(record)}
                >
                  <i className="fa-solid fa-download me-2"></i>
                  Receive Stock
                </Link>

                <Link
                  to="#"
                  className={`dropdown-item ms-3 my-3 ${
                    uploadType ? "" : "disabled"
                  }`}
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRightUploadFiles"
                  aria-controls="offcanvasRightUploadFiles"
                  onClick={() => {
                    if (uploadType) {
                      showUploadFilesModal(record, uploadType);
                    }
                  }}
                >
                  <i className="fa-solid fa-cloud-arrow-up me-2"></i>
                  Upload Files
                </Link>
              </div>
            </div>
          </td>
        );
      },
    },
  ];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based, so add 1
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const showEditModal = (TransferObj) => {
    setEditTransferObj(TransferObj);
  };

  const showUploadFilesModal = (transferObj, uploadType) => {
    console.log(
      transferObj.TransferId,
      uploadType,
      "getign id adn type before upload"
    );
    setUploadTransferObj(transferObj.TransferId);
    setUploadType(uploadType);
  };

  const generatePDF = () => {
    const doc = new jsPDF();

    // Set properties for PDF
    doc.setProperties({
      title: " stockTransfer",
      author: "Your Name",
      creator: "Your Application",
    });

    // Add data to PDF
    const tableData = []; // Your data array here

    // Add a header row
    const headers = [
      "Transfer Order",
      "Transfer Date",
      "From Store",
      "To Store",
      "Status",
    ];
    tableData.push(headers);

    // Add rows
    filteredData.forEach((item) => {
      const row = [];
      row.push(
        `ST${item.AutoGenTransactionNo}`,
        formatDate(item.TransferDate),
        item.FromStore,
        item.ToStore,
        item.Status
      );
      tableData.push(row);
    });

    // Generate table
    doc.autoTable({
      head: [headers],
      body: tableData.slice(1),
    });

    // Save the PDF
    doc.save("stockTransfer.pdf");
  };

  const generateEXCEL = () => {
    if (filteredData.length === 0) {
      return; // Don't download if there is no data
    }

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Define headers for the worksheet
    const headers = [
      "Transfer Order",
      "Transfer Date",
      "From Store",
      "To Store",
      "Status",
    ];

    // Convert your data to worksheet format
    const wsData = filteredData.map((item) => ({
      "Transfer Order": `ST${item.AutoGenTransactionNo}`,
      "Transfer Date": formatDate(item.TransferDate),
      "From Store": item.FromStore,
      "To Store": item.ToStore,
      Status: item.Status,
    }));

    // Add headers as the first row
    wsData.unshift({
      "Transfer Order": headers[0],
      "Transfer Date": headers[1],
      "From Store": headers[2],
      "To Store": headers[3],
      Status: headers[4],
    });

    // Convert the data to a worksheet
    const ws = XLSX.utils.json_to_sheet(wsData, { skipHeader: true });

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "StockTransferData");

    // Save the workbook to a file
    XLSX.writeFile(wb, "StockTransfer.xlsx");
  };

  const handleReload = () => {
    window.location.reload();
  };

  const printRef = useRef();

  useEffect(() => {
    let totalTransfQty = 0;
    let totalReqqty = 0;

    if (stockTRPdf && stockTRPdf.length > 0) {
      totalReqqty = stockTRPdf.reduce((acc, product) => {
        const amount = product.ReqQuantity;
        return acc + (amount || 0);
      }, 0);

      totalTransfQty = stockTRPdf.reduce((acc, product) => {
        const amount = product.TransferQty;
        return acc + (amount || 0);
      }, 0);
    }

    setTotalTransferQty(totalTransfQty);
    setTotalReqQty(totalReqqty);
  }, [stockTRPdf]);

  // const printRecord = async (id) => {
  //   try {
  //     const response = await Axios.get(
  //       `${API_BASE_URL}${GET_TRANSFER_STOCK_PDF}?OrgId=${userDataSession.OrgId}&TransactionId=${id}`
  //     );

  //     if (response.data.Status) {
  //       setStockTRPdf(response.data.ResultData);
  //       setTimeout(() => {
  //         window.print();
  //       }, 500);
  //     } else {
  //       console.error("Error fetching data:", response.data.Message);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error.message || error);
  //   }
  // };

  const [isDownloadTriggered, setIsDownloadTriggered] = useState(false);

  const printRecord = async (id) => {
    try {
      const response = await Axios.get(
        `${API_BASE_URL}${GET_TRANSFER_STOCK_PDF}?OrgId=${userDataSession.OrgId}&TransactionId=${id}`
      );

      if (response.data.Status) {
        setStockTRPdf(response.data.ResultData);

        setTimeout(() => {
          const printContents = document.querySelector(".container.col-12").innerHTML;
          const printWindow = window.open("", "_blank");

          printWindow.document.write(`
            <html>
              <head>
                <title>Print Stock Transfer</title>
                <style>
                  body {
                    font-family: Arial, sans-serif;
                    margin: 0;
                    padding: 20px;
                    margin-top: -30px;
                  }
                  table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-top: -20px;
                  }
                  th, td {
                    border: 1px solid black;
                    padding: 8px;
                    text-align: left;
                    font-size: 10px;
                  }
                    .storenames {
                      margin-top: -10px;
                    }
                </style>
              </head>
              <body>
                ${printContents}
              </body>
            </html>
          `);

          printWindow.document.close();
          printWindow.focus();
          printWindow.print();
          printWindow.close();
        }, 500);
      } else {
        console.error("Error fetching data:", response.data.Message);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message || error);
    }
  };

  const downloadPDF = async (id) => {
    try {
      const response = await Axios.get(
        `${API_BASE_URL}${GET_TRANSFER_STOCK_PDF}?OrgId=${userDataSession.OrgId}&TransactionId=${id}`
      );

      if (response.data.Status) {
        setStockTRPdf(response.data.ResultData);
        setIsDownloadTriggered(true);
      } else {
        console.error("Error fetching data:", response.data.Message);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message || error);
    }
  };

  useEffect(() => {
    if (stockTRPdf.length > 0 && isDownloadTriggered) {
      const element = printRef.current;
      setIsVisible(true);
      setIsVisible1(false);

      html2pdf().from(element).save("StockTransfer.pdf").then(() => {
        setIsVisible(false);
        setIsVisible1(true);
        setIsDownloadTriggered(false); // Reset download trigger
      });
    }
  }, [stockTRPdf, isDownloadTriggered]);


  return (
    <>
      <div
        className="page-wrapper"
        style={{ display: isVisible1 ? "block" : "none" }}
      >
        <div className="content">
          {/* /Stock transfer list */}
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Stock Transfer List</h4>
                <h6>Manage your Transfers</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li onClick={generatePDF}>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li onClick={generateEXCEL}>
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li onClick={handleReload}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    // className={data ? "active" : ""}
                    // onClick={() => { dispatch(setToogleHeader(!data)) }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            <div className="d-flex">
              <div className="d-flex purchase-pg-btn me-2">
                <div className="page-btn">
                  <Link
                    to="#"
                    className={`btn btn-added ${permissions.isRead}`}
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasRightAddStockTrnsf"
                    aria-controls="offcanvasRightAddStockTrnsf"
                  >
                    <PlusCircle className="me-2" />
                    By Product
                  </Link>
                </div>
              </div>
              <div className="d-flex purchase-pg-btn">
                <div className="page-btn">
                  <Link
                    to="#"
                    className={`btn btn-added ${permissions.isRead}`}
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasRightIndentAddStockTrnsf"
                    aria-controls="offcanvasRightIndentAddStockTrnsf"
                  >
                    <PlusCircle className="me-2" />
                    By Indent
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control form-control-sm formsearch"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
                <div className="search-path">
                  <Link
                    className={`btn btn-filter ${
                      isFilterVisible ? "setclose" : ""
                    }`}
                    id="filter_search"
                  >
                    <Filter
                      className="filter-icon"
                      onClick={toggleFilterVisibility}
                    />
                    <span onClick={toggleFilterVisibility}>
                      <ImageWithBasePath
                        src="assets/img/icons/closes.svg"
                        alt="img"
                      />
                    </span>
                  </Link>
                </div>
                {/* <div className="form-sort stylewidth">
                  <Sliders className="info-img" />

                  <Select
                    className="select "
                    options={options}
                    placeholder="Sort by Date"
                  />
                </div> */}
              </div>
              {/* /Filter */}
              <div
                className={`card${isFilterVisible ? "" : ""}`}
                id="filter_inputs"
                style={{ display: isFilterVisible ? "none" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="row">
                    <div className="col-lg-3 col-sm-6 col-12">
                      <div className="input-blocks">
                        <Archive className="info-img" />
                        <Select
                          className="select"
                          options={warehouseOptions}
                          placeholder="Warehouse From"
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12">
                      <div className="input-blocks">
                        <User className="info-img" />
                        <Select
                          className="select"
                          options={destinationOptions}
                          placeholder="Warehouse To"
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12">
                      <div className="input-blocks">
                        <Calendar className="info-img" />
                        <div className="input-groupicon">
                          <DatePicker
                            selected={selectedDate}
                            onChange={handleDateChange}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Choose Date"
                            className="datetimepicker"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12 ms-auto">
                      <div className="input-blocks">
                        <a className="btn btn-filters ms-auto">
                          {" "}
                          <i
                            data-feather="search"
                            className="feather-search"
                          />{" "}
                          Search{" "}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Filter */}
              <div className="table-responsive">
                {loading ? (
                  // <div className="loader m-auto"></div>
                  <SpinLoader/>
                ) : (
                  <Table
                    className="table datanew"
                    columns={columns}
                    dataSource={filteredData}
                    // pagination={true}
                  />
                )}
              </div>
            </div>
          </div>
          {/* /Stock transfer list */}
        </div>

        <StockTransferModal transferObj={editTransferObj} />
        <IndentStockTransferModal transferObj={editTransferObj} />
        <UploadFiles number={uploadTransferObj} type={uploadType} />
      </div>

      <div
        ref={printRef}
        className="container col-12 stores"
        style={{ display: isVisible ? "block" : "none" }}
      >
        <div
          className="center-image"
          style={{ textAlign: "center", margin: "10px" }}
        >
          <img
            src={PrintLogoImg}
            alt="Logo"
            width="160px"
            height="60px"
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            lineHeight: "1",
          }}
        >
          <h5>
            Stock Transfer (TR - {stockTRPdf?.[0]?.AutoGenTransactionNo || ""})
          </h5>
          <h4 style={{ margin: 0 }}>
            Date: {formatDate(stockTRPdf?.[0]?.TransferDate)}
          </h4>
        </div>
        <div
          className="d-flex"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "10px",
            paddingLeft: "15px",
          }}
        ></div>
        <div
          className="vendor-ship"
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <div style={{ width: "48%" }} className="storenames">
            <p
              className="ship"
              style={{
                // backgroundColor: "#FF9F43",
                color: "black",
                // padding: "10px",
                fontWeight: "bold",
                lineHeight: "0.5",
              }}
            >
              <strong>To Store</strong>
            </p>
            <p style={{ lineHeight: "0.3", fontSize: '10px' }}>
              Name: {stockTRPdf?.[0]?.ToStore || ""}
            </p>
            <p style={{ lineHeight: "0.3", fontSize: '10px' }}>
              Phone No: {stockTRPdf?.[0]?.ToStPhone}
            </p>
            <p style={{ lineHeight: "0.3", fontSize: '10px' }}>
              Email Id: {stockTRPdf?.[0]?.ToStEmail}
            </p>
            <p style={{ lineHeight: "0.3", fontSize: '10px' }}>
              City: {stockTRPdf?.[0]?.ToStCity || ""}
            </p>
            <p style={{ lineHeight: "0.3", fontSize: '10px' }}>
              State: {stockTRPdf?.[0]?.ToStState || ""}
            </p>
            <p style={{ lineHeight: "0.9", fontSize: '10px' }}>
              Address: {stockTRPdf?.[0]?.ToStAddress || ""}
            </p>
          </div>
          <div style={{ width: "48%" }} className="storenames">
            <p
              className="ship"
              style={{
                // backgroundColor: "#FF9F43",
                color: "black",
                // padding: "10px",
                fontWeight: "bold",
                lineHeight: "0.5",
              }}
            >
              <strong>From Store</strong>
            </p>
            <p style={{ lineHeight: "0.3", fontSize: '10px' }}>
              Name: {stockTRPdf?.[0]?.FromStore || ""}
            </p>
            <p style={{ lineHeight: "0.3", fontSize: '10px' }}>
              Phone No: {stockTRPdf?.[0]?.FrStPhone}{" "}
            </p>
            <p style={{ lineHeight: "0.3", fontSize: '10px' }}>
              Email Id: {stockTRPdf?.[0]?.FrStEmail}
            </p>
            <p style={{ lineHeight: "0.3", fontSize: '10px' }}>
              City: {stockTRPdf?.[0]?.FrStCity || ""}
            </p>
            <p style={{ lineHeight: "0.3", fontSize: '10px' }}>
              State: {stockTRPdf?.[0]?.FrStState || ""}
            </p>
            <p style={{ lineHeight: "0.9", fontSize: '10px' }}>
              Address: {stockTRPdf?.[0]?.FrStAddress || ""}
            </p>
          </div>
        </div>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginBottom: "15px",
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "5px", 
                  textAlign: "left",
                  backgroundColor: "#FF9F43",
                  color: "black",
                  lineHeight: "1", 
                }}
              >
                #
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "5px",
                  textAlign: "left",
                  backgroundColor: "#FF9F43",
                  color: "black",
                  lineHeight: "1",
                }}
              >
                Item
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "5px",
                  textAlign: "left",
                  backgroundColor: "#FF9F43",
                  color: "black",
                  lineHeight: "1",
                }}
              >
                Request Qty
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "5px",
                  textAlign: "left",
                  backgroundColor: "#FF9F43",
                  color: "black",
                  lineHeight: "1",
                }}
              >
                Transfer Qty
              </th>
            </tr>
          </thead>
          <tbody>
            {stockTRPdf?.map((item, index) => (
              <tr key={index}>
                <td
                  style={{
                    border: "0.4px solid #000",
                    padding: "5px",
                    lineHeight: "0.8",
                  }}
                >
                  {index + 1}
                </td>
                <td
                  style={{
                    border: "0.4px solid #000",
                    padding: "5px",
                    lineHeight: "0.8",
                  }}
                >
                  {item.ProductName}
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "5px",
                    lineHeight: "0.8",
                  }}
                >
                  {item.ReqQuantity}
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "5px",
                    lineHeight: "0.8",
                  }}
                >
                  {item.TransferQty}
                </td>
              </tr>
            ))}
            {/* Totals Row */}
            <tr>
              <td
                colSpan="2"
                style={{
                  border: "1px solid #000",
                  padding: "5px",
                  fontWeight: "bold",
                  textAlign: "right",
                  lineHeight: "0.8",
                }}
              >
                Total:
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "5px",
                  fontWeight: "bold",
                  textAlign: "left",
                  lineHeight: "0.8",
                }}
              >
                {totalReqQty}
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "5px",
                  fontWeight: "bold",
                  textAlign: "left",
                  lineHeight: "0.8",
                }}
              >
                {totalTransferQty}
              </td>
            </tr>
          </tbody>
        </table>

        <div className="mb-3 d-flex" style={{ fontSize: '8px' }}>
          <p>Tracking Details:</p>
          <p className="ms-1">{stockTRPdf?.[0]?.TrackingDetails}</p>
        </div>

        <div className="d-flex row">
          <div className="col-12">
            <p style={{ lineHeight: "0.3", fontSize: '9px' }}>
              <strong>Comments or Special Instructions:</strong>
            </p>
            <p style={{ lineHeight: "0.3", fontSize: '9px' }}>
              - Please verify the quantities upon receipt.
            </p>
            <p style={{ lineHeight: "0.3", fontSize: '9px' }}>
              - Notify us immediately if there are any discrepancies or damages.
            </p>
            <p style={{ lineHeight: "0.3", fontSize: '9px' }}>
              - Ensure all items are stored as per the guidelines to maintain
              quality.
            </p>
            <p style={{ lineHeight: "0.4", fontSize: '9px' }} className="text-center text-info">
              Thank you for your business.
            </p>
          </div>
        </div>

        <div
          className="footer"
          style={{
            fontSize: "12px",
            textAlign: "center",
            color: "gray",
            marginTop: "20px",
          }}
        >
          {/* <p style={{ lineHeight: "0.6" }}>
            If you have any questions about this Stock Transfer, please contact {stockTRPdf?.[0]?.ToStPhone}
          </p> */}
          <p style={{ fontSize: '7px' }} className="text-center">Powered by<a href="https://perennialcode.in/" target="_blank" rel="noreferrer">PerennialCode.</a></p>
        </div>
      </div>
    </>
  );
};

export default StockTransfer;
